<template>
  <div class="coming-soon-ui-container">
    <div class="coming-soon-icon">
      <i class="far fa-fw fa-star-shooting fa-rotate-180"></i>
    </div>
    <h2 class="coming-soon-header">Coming&nbsp;Soon!</h2>
    <p class="coming-soon-message">We'll have more to show you in this part of the new SharpCharts Workbench very&nbsp;soon</p>
  </div>
</template>

<style scoped>
  .coming-soon-ui-container {
    margin: 10px;
    padding: 45px 60px;
    background-color: #f2f5f7;
    border-radius: 10px;
    text-align: center;
  }

  .coming-soon-icon {
    line-height: 2;
    font-size: 45px;
    color: #f9690e;
  }

  .coming-soon-header {
    color: #333;
    margin: 0px 0px 30px 0px;
    line-height: 1.25;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 30px;
    font-weight: bold;
  }

  .coming-soon-message {
    margin: 0px 0px 15px 0px;
    line-height: 1.4;
    font-size: 16px;
    font-weight: normal;
    color: #5a6672;
  }
</style>
